import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

const CheckoutForm = forwardRef((props, ref) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  // const [isLoading, setIsLoading] = useState(false);


  const handleError = (error) => {
    props.setIsLoading(false);
    setMessage(error.message);
  }

  useImperativeHandle(ref, () => ({
    async handleSubmit (e)  {
      e.preventDefault();

      if (!stripe || !elements) {
        // Stripe.js has not yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
      }

      props.setIsLoading(true);

      const { error: submitError } = await elements.submit();
      if (submitError) {
        handleError(submitError);
        return;
      }

      let clientSecret = props.clientSecret;
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          // Make sure to change this to your payment completion page
          return_url: `${window.location.origin}/order-complete`,
        },
      });

      // This point will only be reached if there is an immediate error when
      // confirming the payment. Otherwise, your customer will be redirected to
      // your `return_url`. For some payment methods like iDEAL, your customer will
      // be redirected to an intermediate site first to authorize the payment, then
      // redirected to the `return_url`.
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occured.");
      }

      props.setIsLoading(false);
    }
  }));

  return (
    <>
      <PaymentElement id="payment-element" />
      {/* <button disabled={isLoading || !stripe || !elements} id="submit" className='btn btn-dark mt-3' onClick={handleSubmit}>
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button> */}
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </>
  );
});

export default CheckoutForm;